export default {
  LOGIN_PAGE: '/login.html',
  HOME_PAGE: '/client/home.html',
  RESET_PASSWORD: '/reset-password.html',
  FORGOT_PASSWORD: '/forgot-password.html',
  SIGNUP: '/signup.html',
};
